import React, { useState } from 'react'
import { GeoHash } from 'geohash'
import AnonymousQA from './AnonymousQA'
import diceIcon from '../images/dice.svg'
import whisprIconBackground from '../images/whispr_icon_background.svg'
import errorIcon from '../images/error.svg'
import axios from 'axios'
import btnStyles from '../styles/button.module.css'
import loaderStyles from '../styles/loader.module.css'
import errorStyles from '../styles/error.module.css'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import '../i18n'

const replyFormStyles = {
	width: '100%',
	marginTop: 44
}

const replyBoxStyles = {
	// width: '327px',
	minHeight: '206px',
	borderRadius: '20px',
	boxShadow: '0px 0px 24px 0px #0000000D',
	position: 'relative'
}

const labelStyles = {
	display: 'flex',
	gap: 10,
	backgroundColor: 'rgba(0, 0, 0, .30)',
	borderRadius: '20px 20px 0 0',
	padding: 16,
	minHeight: 82,
	fontWeight: 600,
	wordBreak: 'break-word',
	alignItems: 'center'
}

const profileImgStyles = {
	borderRadius: '100%',
	width: 46,
	height: 46,
	// border: '2px solid #FFFFFF',
	fontSize: 10,
	boxShadow: '3px 3px 8px rgba(0, 0, 0, 0.25)'
}

const textareaStyles = {
	resize: 'none',
	padding: 20,
	borderRadius: '0 0 20px 20px',
	border: 'none',
	width: '100%',
	minHeight: 124,
	fontFamily: "'Noto Sans', sans-serif",
	fontSize: 18
}

const diceIconStyles = {
	position: 'absolute',
	width: 42,
	height: 42,
	right: 10,
	bottom: 15,
	border: '1px solid #ECF0F2',
	borderRadius: '100%',
	padding: 8,
	backgroundColor: '#F7F8FA',
	cursor: 'pointer'
}

const BIG_DATA_CLOUD_API =
	'https://api.bigdatacloud.net/data/reverse-geocode-client'

const PostReplyBox = ({ profileImage, post, postId, onReplying }) => {
	const [reply, setReply] = useState('')
	const [error, setError] = useState(false)
	const [loading, setLoading] = useState(false)
	let navigate = useNavigate()
	const { t } = useTranslation()

	const apiBaseUrl = `${process.env.REACT_APP_API_BASE_URL}${process.env.REACT_APP_BASE_URL_PREFIX}`
	axios.defaults.baseURL = apiBaseUrl

	const handleRandomReply = async () => {
		try {
			const resp = await axios.get('/random-reply')
			setReply(resp.data.randomReply)
			onReplying(true)
		} catch (error) {
			console.log('Failed to fetch random reply:', error)
			setReply('❤️‍🔥❤️‍🔥❤️‍🔥')
			onReplying(true)
		}
	}

	const handleReplyChange = (e) => {
		setReply(e.target.value)
		onReplying(e.target.value.length > 0) // Call the callback with true if there is text
	}

	const handleKeyDown = (e) => {
		if (e.key === 'Enter') {
			e.preventDefault()
		}
	}

	const handleSubmit = async (e) => {
		e.preventDefault()
		setError(false)
		setLoading(true)

		let locationData
		try {
			const locationResp = await axios.get(BIG_DATA_CLOUD_API, {
				withCredentials: false
			})
			locationData = locationResp.data
		} catch (locationError) {
			console.log('Error fetching location data:', locationError)
		}

		const replyData = {
			postId,
			replierId: localStorage.getItem('replierId'),
			content: reply,
			country: locationData?.countryName || undefined,
			city: locationData?.city || undefined,
			locality: locationData?.locality || undefined,
			geoHash: locationData
				? GeoHash.encodeGeoHash(locationData.latitude, locationData.longitude)
				: undefined
		}
		try {
			const resp = await axios.post(`/reply`, replyData, {
				withCredentials: true
			})
			localStorage.setItem('replierId', resp.data.replierId)
			navigate('/sent')
		} catch (error) {
			setError(true)
			console.log('Fail to send reply', error)
		}
		setLoading(false)
	}

	return (
		<>
			<form onSubmit={handleSubmit} style={replyFormStyles}>
				<div style={replyBoxStyles}>
					<label style={labelStyles} htmlFor='message'>
						<img
							alt='profile'
							style={profileImgStyles}
							src={profileImage || whisprIconBackground}
						/>
						{post}
					</label>
					<textarea
						style={textareaStyles}
						name='content'
						id='message'
						placeholder={t('messagePlaceholder')}
						value={reply}
						onChange={handleReplyChange}
						maxLength='250'
						onKeyDown={handleKeyDown}
					></textarea>
					<div style={diceIconStyles} onClick={handleRandomReply}>
						<img src={diceIcon} alt='dice icon'></img>
					</div>
				</div>
				<AnonymousQA />
				{reply && (
					<div className={btnStyles['btn-wrapper']}>
						<button type='submit' className={btnStyles.btn}>
							{loading ? (
								<span className={loaderStyles.spinner}></span>
							) : (
								t('sendButton')
							)}
						</button>
					</div>
				)}
			</form>

			{error && (
				<p className={errorStyles.error}>
					<img src={errorIcon} alt='error' />
					Failed to send the reply message
				</p>
			)}
		</>
	)
}

export default PostReplyBox
